import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/inspection/$licenseId")({
  component: () => <Outlet />,
});
